module.exports = __webpack_public_path__ + "static/video-ddd-09be0af194e9457095e89b3097db4903.mp4";